import Immutable from 'seamless-immutable';
import { createReducer, completeState, completeReducer, onReadValue } from 'redux-recompose';

import { actions } from './actions';
import { CHECKLISTS_DEFAULT_STATE } from './constants';

const completedState = completeState(CHECKLISTS_DEFAULT_STATE);

const reducerDescription = {
  primaryActions: [actions.CREATE_CHECKLIST, actions.GET_ALL_CHECKLISTS, actions.EDIT_CHECKLIST],
  override: { [actions.SET_CURRENT_CHECKLIST]: onReadValue() }
};

const reducer = createReducer(new Immutable(completedState), completeReducer(reducerDescription));

export default reducer;
